import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from 'src/reducers/RootReducer';
import Project from 'src/entities/Project';
import ReviewContractsComponent
  from 'src/modules/project/partials/project-formalization/partials/review-contracts/ReviewContracts.component';
import ModifyContractsContainer from 'src/modules/modals/modify-contracts/ModifyContracts.container';
import { OpenModal, openModal } from 'src/actions/modal';
import ResultPageCardComponent from 'src/modules/commons/result-page/ResultPageCard.Component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Investment from 'src/entities/Investment';

interface StateProps {
}

export interface OwnProps {
  project: Project;
  investment: Investment;
  modalRef?: Modal;

  setInvestment(investment: Investment, step: string): void;
}

interface DispatchProps {
  openModal: (component: JSX.Element) => void;
}

interface Props extends StateProps, OwnProps, DispatchProps {
}

class ReviewContractsContainer extends React.Component<Props> {

  public state = {
    success: false
  };

  public render(): React.ReactNode {
    if (this.state.success) {
      return (
        <ResultPageCardComponent
          title="Gracias por comunicarnos la errata."
          message="el equipo de soporte al inversor revisará tu caso y te informaremos de los cambios."
          success={true}
        />
      );
    }
    return (
      this.props.investment ?
        (
          <ReviewContractsComponent
            project={this.props.project}
            investment={this.props.investment}
            handleSubmitDocument={(typeDocument: boolean) => this.handleAcceptDocument(typeDocument)}
            handleModifyDocument={() => this.handleModifyDocument()}
          />
        ) :
        null
    );
  }

  private handleModifyDocument(): void {
    this.props.openModal(
      <ModifyContractsContainer
        investment={this.props.investment}
        correctionCreated={() => this.correctionCreated()}
        modalRef={this.props.modalRef}
      />
    );
  }

  private correctionCreated(): void {
    this.setState({
      success: true
    });
    let newInvestment: Investment;
    newInvestment = {
      ...this.props.investment,
      status: 'Reviewing Contracts Correction'
    };
    this.props.setInvestment(newInvestment, newInvestment.status!);
  }

  private handleAcceptDocument(typeDocument: boolean) {
    let newInvestment: Investment;
    let status: string;
    if (this.props.investment.acceptedSyndicateAgreement || this.props.investment.acceptedShareholderAgreement) {
      status = 'Accepted Contracts';
    } else {
      status = 'Reviewing Contracts';
    }
    if (typeDocument) {
      newInvestment = {
        ...this.props.investment,
        acceptedSyndicateAgreement: true,
        status: status
      };
    } else {
      newInvestment = {
        ...this.props.investment,
        acceptedShareholderAgreement: true,
        status: status
      };
    }
    this.props.setInvestment(newInvestment, newInvestment.status!);
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  openModal: (component: JSX.Element): OpenModal => {
    return dispatch(openModal(component));
  }
});

export default connect(null, mapDispatchToProps)(ReviewContractsContainer);



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/review-contracts/ReviewContracts.container.tsx